// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.search-bar-desktop-layout {
    display: flex;
    flex-direction: row;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
    }
    .product-list-content {
      width: 75%;
      padding-left: 50px;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        padding-left: 36px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        width: 100%;
        padding-left: 0;
        min-height: auto;
      }
      @media ${(props) => props.theme.mediaQuery.desktop} {
        padding-left: 95.5px;
      }
    }
    .text-list-content {
      margin-left: 116px;
      width: 14%;

      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        width: 20%;
        margin-left: 86px;
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        width: 20%;
      }
      @media ${(props) => props.theme.mediaQuery.desktop} {
        width: 16%;
      }
      @media (min-width: 1200px) and (max-width: 1350px) {
        width: 24%;
      }
      @media (min-width: 768px) and (max-width: 960px) {
        width: 30%;
      }
      border-right: 1px solid ${(props) => props.theme.colors.BORDER.GRAY};
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        width: 100%;
        margin-left: 0;
        border-right: none;
        margin-bottom: 24px;
        border-bottom: 1px solid ${(props) => props.theme.colors.BORDER.GRAY};
      }
      @media (min-width: 375px) and (max-width: 385px) {
        margin-bottom: 20px;
      }
      @media (max-height: 705px) {
        margin-bottom: 20px;
      }
    }
    .text-list-content.no-matches {
      border-right: none;
    }
  }
`;
